/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FacilityGroupDto } from '../../models/facility-group-dto';

export interface GetFacilityGroupsByCustomer$Params {
  customerId?: number;
}

export function getFacilityGroupsByCustomer(http: HttpClient, rootUrl: string, params?: GetFacilityGroupsByCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FacilityGroupDto>>> {
  const rb = new RequestBuilder(rootUrl, getFacilityGroupsByCustomer.PATH, 'get');
  if (params) {
    rb.query('customerId', params.customerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FacilityGroupDto>>;
    })
  );
}

getFacilityGroupsByCustomer.PATH = '/api/facilitygroup';
